export const styles = {
  popUpContainer: {
    backgroundColor: "var(--surface)",
    color: "white",
    boxShadow: "24px",
    padding: "10px",
    margin: "0 10px 10px 0",
    width: "100%",
  } as const,
  progressContainer: {
    display: "flex",
    alignItems: "center",
  } as const,
  infoContainer: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    justifyContent: "space-between",
  } as const,
  progressWrapper: {
    display: "flex",
    alignContent: "center",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "space-between",
    height: "100%",
  } as const,
  uploadingFilesDetailsListContainer: {
    position: "fixed",
    bottom: -8,
    left: "10px",
    padding: "16px",
    margin: "0 10px 10px 0",
    zIndex: 30000,
    borderRadius: "20px",
    width: "380px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingTop: "5px",
    backgroundColor: "var(--surface)",
  } as const,
  fullScreenUploadingFilesDetailsListContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "var(--bg)",
    zIndex: 1300,
    overflow: "auto",
    padding: "16px",
    paddingTop: "5px",
  } as const,
  progressText: {
    fontSize: "14px",
    paddingTop: "5px",
    marginLeft: "10px",
  } as const,
  scrollBox: {
    overflow: "auto",
    overflowX: "hidden",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  topBar: {
    height: "30px",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
  } as const,
  boxStyle: {
    width: "100%",
    border: "1px solid var(--border)",
    marginTop: "3px"
  } as const,
  uploadingContainer: {
    padding: "8px",
    margin: 0,
    fontSize: "17px",
    color: "white"
  } as const,
  buttonBase: {
    padding: "8px",
    color: "white"
  } as const,
  fileNameText: {
    fontSize: "14px",
    paddingTop: "5px"
  } as const,
  circularProgress: {
    padding: "6px",
    marginTop: "5px"
  } as const,
};
